import { proxy, useSnapshot } from 'valtio';

interface ManualPositionWarningDialogState {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const manualPositionWarningDialogState = proxy<ManualPositionWarningDialogState>({
  open: false,
  onConfirm: () => {},
  onCancel: () => {},
});

export const closeManualPositionWarningDialog = (): void => {
  manualPositionWarningDialogState.open = false;
  manualPositionWarningDialogState.onConfirm = () => {};
  manualPositionWarningDialogState.onCancel = () => {};
};

export const resetManualPositionWarningDialogState = (): void => {
  closeManualPositionWarningDialog();
};

export const setManualPositionWarningDialog = (
  open: boolean,
  onConfirm: () => void,
  onCancel?: () => void,
): void => {
  manualPositionWarningDialogState.open = open;
  manualPositionWarningDialogState.onConfirm = onConfirm;
  manualPositionWarningDialogState.onCancel = onCancel ?? (() => {});
};

export const useManualPositionWarningDialogState = () => ({
  ...useSnapshot(manualPositionWarningDialogState),
  setManualPositionWarningDialog,
  closeManualPositionWarningDialog,
});
